const ApiUrl = `${process.env.VUE_APP_API_PP_PARTIDOS}`;

import axios from "@/interceptor-core";

export const requestRevisionMixin = {
  methods: {
    async crearRevision(body) {
      return await axios.post(`${ApiUrl}/revision/crear`, body);
    },
    async crearSelectionRevision(body) {
      return await axios.post(`${ApiUrl}/revision/crear-bulk`, body);
    },
    async listaRevision(body) {
      return await axios.post(`${ApiUrl}/revision/lista`, body);
    },
    async getRevisionEstado() {
      return await axios.post(`${ApiUrl}/revision/estado`);
    },
    async getRevisionMotivoRechazo() {
      return await axios.get(`${ApiUrl}/revision/motivorechazo`);
    },
    async getListaAfiliacionRevision(body = {}) {
      return await axios.post(`${ApiUrl}/afiliacion/revision/lista`, body);
    },
    async getAfiliacionRevisionVer(id) {
      const body = {
        id: id,
      };

      return await axios.post(`${ApiUrl}/afiliacion/revision/ver`, body);
    },
    async getRevisionVer(id) {
      const body = {
        id: id,
      };

      return await axios.post(`${ApiUrl}/revision/ver`, body);
    },
  },
};
